import React from "react";
import {
  Alert,
  Button,
  Form,
  FormFeedback,
  FormGroup,
  FormInput,
  FormRadio,
} from "shards-react";

import { register } from "../../backend/user";
import { UserContext } from "../../backend/userContext";

class FormSignUp extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      type: "consumer",
      email_check: null,
      password_check: null,
      user: null,
      nick: "",
      error: null,
    };
    this.changeType = this.changeType.bind(this);
    this.changeEmail = this.changeEmail.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeNick = this.changeNick.bind(this);
  }

  handleSubmit(event) {
    //console.log("Registering user");
    event.preventDefault();
    if (this.state.email_check && this.state.password_check) {
      let user = {
        username: this.state.email,
        password: this.state.password,
        nick: this.state.nick,
        type: this.state.type,
        priviledges: this.state.type === "admin" ? "admin" : "user",
      };

      //console.log("### Login Error", user)
      register(
        user,
        (data) => {
          this.setState({ error: false });
        },
        (error) => {
          if (error.name === "UserExistsError") {
            this.setState({
              error: "Error registrando usuario: El usuario ya existe",
            });
          } else {
            this.setState({
              error: "Error registrando usuario: " + error.stringify(),
            });
          }
        }
      );
    }
  }

  changeType(type) {
    this.setState({ type: type });
  }

  changeEmail(event) {
    let email = event.target.value;
    const expression =
      /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

    if (expression.test(String(email).toLowerCase())) {
      this.setState({ email: email, email_check: true });
    } else {
      this.setState({ email: email, email_check: false });
    }
  }

  changePassword(event) {
    let password = event.target.value;
    const strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
    );

    if (strongRegex.test(String(password))) {
      this.setState({ password: password, password_check: true });
    } else {
      this.setState({ password: password, password_check: false });
    }
  }

  changeNick(event) {
    this.setState({ nick: event.target.value });
  }

  errorband(error) {
    if (error === null) {
      return null;
    }
    let theme = "danger";
    let message = error;
    if (error === false) {
      theme = "success";
      message = `Registrado nuevo usuario`;
    }
    return (
      <Alert className={"mt-2"} theme={theme}>
        {message}
      </Alert>
    );
  }

  render() {
    //console.log("user "+this.context.user);
    return (
      <Form onSubmit={this.handleSubmit}>
        <FormGroup>
          <label>Email</label>
          <FormInput
            placeholder="email"
            required
            type="text"
            valid={this.state.email_check}
            invalid={
              this.state.email_check === null ? null : !this.state.email_check
            }
            onChange={(event) => this.changeEmail(event)}
          />
          <FormFeedback>Escribe un email valido</FormFeedback>
          <FormFeedback valid={true}>Parece correcto</FormFeedback>
        </FormGroup>
        <FormGroup>
          <label>Nick</label>
          <FormInput
            placeholder="nick"
            required
            type="text"
            onChange={(event) => this.changeNick(event)}
          />
        </FormGroup>
        <FormGroup>
          <label>Password</label>
          <FormInput
            placeholder="password"
            required
            type="password"
            valid={this.state.password_check}
            invalid={
              this.state.password_check === null
                ? null
                : !this.state.password_check
            }
            onChange={(event) => this.changePassword(event)}
          />
          <FormFeedback>
            La contraseña debe tener 8 caracteres, una mayuscula y un numero
          </FormFeedback>
          <FormFeedback />
          <FormFeedback valid={true}>Parece correcto</FormFeedback>
        </FormGroup>
        <div key={"type-radio"} className="ml-auto">
          <legend>Tipo</legend>
          <FormGroup>
            <FormRadio
              name="Type"
              label={"consumer"}
              checked={this.state.type === "consumer"}
              onChange={() => this.changeType("consumer")}
            >
              Consumidor
            </FormRadio>
            <FormRadio
              name="Type"
              label={"Producer"}
              checked={this.state.type === "producer"}
              onChange={() => this.changeType("producer")}
            >
              Productor
            </FormRadio>
            <FormRadio
              name="Type"
              label={"Administrador"}
              checked={this.state.type === "admin"}
              onChange={() => this.changeType("admin")}
            >
              Administrador
            </FormRadio>
            <FormRadio
              name="Type"
              label={"Revisor"}
              checked={this.state.type === "reviewer"}
              onChange={() => this.changeType("reviewer")}
            >
              Revisor
            </FormRadio>
          </FormGroup>
        </div>
        <Button type="submit">Crear</Button>
        {this.errorband(this.state.error)}
      </Form>
    );
  }
}
export default FormSignUp;
